import { DEPARTMENT_TYPES } from '../../../config/departmentTypes'

export function pluralizeRu(count, one, few, many) {
  const abs = Math.abs(Number(count) || 0)
  const mod100 = abs % 100
  const mod10 = abs % 10

  if (mod100 >= 11 && mod100 <= 14) return many
  if (mod10 === 1) return one
  if (mod10 >= 2 && mod10 <= 4) return few
  return many
}

export function formatDepartmentMeta({ departmentsCount = 0, teamsCount = 0, employeesCount = 0 }) {
  return [
    `${departmentsCount} ${pluralizeRu(departmentsCount, 'подразделение', 'подразделения', 'подразделений')}`,
    `${teamsCount} ${pluralizeRu(teamsCount, 'команда', 'команды', 'команд')}`,
    `${employeesCount} ${pluralizeRu(employeesCount, 'сотрудник', 'сотрудника', 'сотрудников')}`,
  ].join(' · ')
}

export function getDepartmentsTotals(departments) {
  return (departments || []).reduce((totals, department) => ({
    departmentsCount: totals.departmentsCount + 1,
    teamsCount: totals.teamsCount + Number(department?.teams_count || 0),
    employeesCount: totals.employeesCount + Number(department?.employees_count || 0),
  }), { departmentsCount: 0, teamsCount: 0, employeesCount: 0 })
}

export function splitDepartmentsByType(departments) {
  const production = []
  const service = []

  ;(departments || []).forEach((department) => {
    if (department?.department_type === DEPARTMENT_TYPES.PRODUCTION) {
      production.push(department)
    } else {
      service.push(department)
    }
  })

  return { production, service }
}

export function getDepartmentInitials(name) {
  const clean = String(name || '').trim()
  if (!clean) return '—'

  const words = clean.split(/\s+/).filter(Boolean)
  if (words.length > 1) {
    return words.map((word) => word[0]).join('').slice(0, 3).toUpperCase()
  }

  return clean.slice(0, clean.length <= 3 ? 3 : 2).toUpperCase()
}

export function getDepartmentLeadName(department) {
  const heads = Array.isArray(department?.heads) ? department.heads : []
  const head = heads.find((item) => item?.full_name || item?.employee_name || item?.login)

  return head?.full_name || head?.employee_name || head?.login || 'Руководитель не назначен'
}
